import { render, staticRenderFns } from "./BelMe.vue?vue&type=template&id=ba549d72&scoped=true"
import script from "./BelMe.vue?vue&type=script&lang=js"
export * from "./BelMe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba549d72",
  null
  
)

export default component.exports